import debounce from 'lodash/debounce'
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import Chip from '@material-ui/core/Chip';
import { instance } from '../../../ObjectiveCategories/useCategories'
import styled from 'styled-components';
import Stack from '@mui/material/Stack';
import { UserItemRenderer } from '@workboard/ui-search';
import { useClosedKrLock } from '../closedKrLock.context';

const StyledAutocomplete = styled.div`
  .MuiAutocomplete-root {
    display: flex;
    width: 544px;
    max-height: 90px;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    overflow-y: auto;
    background-color: #F2F2F2
  }
  .MuiChip-root {
    height: 32px;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.16px;
    background-color: #FFFFFF
  }
  .MuiChip-root > div > img {
    display: flex;
    width: 24px;
    height: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;


export function MultipleKrCoOwnerSelect({isMitChildKr, realOwnerId, coOwners, updateData, teamId, excludeAIAgents = true}) {
  const [autocompleteOptions, setAutocompleteOptions] = useState([])
  const loading = autocompleteOptions.length > 0
  const [searchText, setSearchText] = useState('')
  const isClosedKr = useClosedKrLock()
  const isReadOnly = isMitChildKr || isClosedKr
  const debouncedSearch = debounce(setSearchText, 300);
  const realOwnerId = realOwnerId;
  let initial_data = coOwners.length ? [...coOwners] : [];
  const [selectedOptions, setSelectedOptions] = useState(initial_data);
  useEffect(() => {
    setSelectedOptions(selectedOptions)
  }, [selectedOptions.length])

  useEffect(() => {
    instance({
      method: 'get',
      url: 'goal/getTeamAndOrgUsersList',
      params: {
        term: searchText,
        teamId,
        excludeAIAgents
      },
    })
      .then((res) => res.data)
      .then((data) => {
        const { data = [] } = data || {}
        let finalValArr =[];
        data.map((user) => {
          if (realOwnerId && user.userId !== realOwnerId) {
            return finalValArr.push({...user,id: user.userId , name: user.label, avatar: user.picture})
          }
        })
        setAutocompleteOptions(finalValArr)
      })
  }, [searchText])

  const handleChange = (value) => {
    let newVal = [...value];
    let finalValArr =[];
    newVal.map((val) => {
        return finalValArr.push({id: (val?.userId || val?.id) , name: (val?.label|| val?.name), avatar: (val?.picture || val?.avatar)})
    })
    setSelectedOptions(finalValArr);
    if (updateData) {
        updateData(finalValArr)
    }
  }

  const handleDelete = (e,item) => {
    const tempTags = [...selectedOptions]
    const tagindex = tempTags.findIndex((x) => x.id === item.id)
    tempTags.splice(tagindex, 1)
    setSelectedOptions(tempTags);
      if (updateData) {
        updateData(tempTags)
      }
  }

  // Key the checkbox indicator on id so it agrees with the id-based selection toggle.
  const isOptionSelected = (option) => !!selectedOptions.find(element => element?.id === option?.id)

  const handleChipRender = (tagValue, getTagProps) => {
    return tagValue.map((option, index) => (
      <Stack direction="row" spacing={1}>
      <Chip
        key={option.id}
        size='small'
        label={option.name}
        icon={<img style={{width: 24, height:24, borderRadius: '100px' }} src={option.avatar} />}
        {...getTagProps({ index })}
        onDelete={(e) => {
          handleDelete(e,option);
        }}
        deleteIcon={<img style={{width: 24,height: 24, display:`${!isReadOnly ? "inline" : "none"}`}}src={`${wbConfig.imageCdnUrl}/images/CloseOutlined.svg`} variant="circular"/> }
      />
      </Stack>
    ))
  }

  return (
      <StyledAutocomplete>
       <Autocomplete
          disabled={isReadOnly}
          disablePortal={true}
          loading={loading}
          autoHighlight={true}
          multiple
          disableCloseOnSelect
          disableClearable
          options={autocompleteOptions || []}
          getOptionLabel={(option) => option?.label || option?.name}
          // Both sides normalize to the user's id (see handleChange), so match on that
          // rather than MUI's default reference equality — needed for it to recognize
          // an already-selected option and remove it on re-click instead of duplicating it.
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          value={selectedOptions}
          onInputChange={(e, text) => {
            if (e) {
              debouncedSearch(text)
            }
          }}
          renderOption={(props, option) => (
            <div {...props} style={{display: "flex", padding: "6px 12px", alignItems: "center", alignSelf: "stretch"}}>
              <UserItemRenderer option={option} selected={isOptionSelected(option)} showCheckbox />
            </div>
          )}
          onChange={(e,v) => handleChange(v)}
          renderTags={handleChipRender}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" />
          )}
        />
        </StyledAutocomplete>
  )
}
